import { render, staticRenderFns } from "./Success-Application.vue?vue&type=template&id=1253d4ae&"
import script from "./Success-Application.vue?vue&type=script&lang=ts&"
export * from "./Success-Application.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports